/**
 * @class
 * @todo Documents defaults
 */
import Base from '@netx/core/lib/netx-model';

export default class PendingAsset extends Base {
	/** @type {string} */
	get idAttribute() {
		return 'assetId';
	}

	/** @type {object} */
	get defaults() {
		return {
			// assetId: undefined,
			categoryIds: [],
			direction: undefined, // 'coming' or 'going'
			state: undefined, // 'uploading', 'importing', 'indexing', etc
		};
	}

	/** @type {string} */
	static get __name__() {
		return 'PendingAsset';
	}
}
